import { render, staticRenderFns } from "./AdInsertionMarkets.vue?vue&type=template&id=fd0c02a2&scoped=true&"
import script from "./AdInsertionMarkets.vue?vue&type=script&lang=js&"
export * from "./AdInsertionMarkets.vue?vue&type=script&lang=js&"
import style0 from "./AdInsertionMarkets.vue?vue&type=style&index=0&id=fd0c02a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0c02a2",
  null
  
)

export default component.exports